// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__w9f+l","contentWrapper":"styles_contentWrapper__XUDde","mainContent":"styles_mainContent__OJhcX","pageContent":"styles_pageContent__Su7mt"};